import { atom, useSetAtom } from "jotai";
import { useEffect } from "react";

const screenWidth = window.innerWidth;
let bsSize;

if (screenWidth >= 1400) {
  bsSize = "lg";
} else if (screenWidth < 1400 && screenWidth >= 1100) {
  bsSize = "md";
} else if (screenWidth < 1100 && screenWidth >= 768) {
  bsSize = "base";
} else if (screenWidth < 768 && screenWidth > 576) {
  bsSize = "sm";
} else if (screenWidth < 576) {
  bsSize = "xs";
} else {
  bsSize = null;
}

export const ScreenSizeAtom = atom(bsSize);

export const IsMobileAtom = atom((get) => {
  const screenSize = get(ScreenSizeAtom);
  return screenSize === "sm" || screenSize === "xs";
});

const App = ({ children }) => {
  const setScreenSize = useSetAtom(ScreenSizeAtom);

  const sizeHandler = (size) => (e) => {
    if (!e.matches) return;

    setScreenSize(size);
  };

  useEffect(() => {
    const mediaQueryXS = window.matchMedia("(max-width: 576px)"); //  If size is below - xs screen
    const mediaQuerySM = window.matchMedia(
      "(min-width: 576px) and (max-width: 768px)"
    ); // If size is between - sm screen
    const mediaQueryBase = window.matchMedia(
      "(min-width: 768px) and (max-width: 1100px)"
    );
    const mediaQueryMD = window.matchMedia(
      "(min-width: 1100px) and (max-width: 1400px)"
    ); // If size is between - md screen
    const mediaQueryLG = window.matchMedia("(min-width: 1400px)"); // If size is above - lg screen

    const handleXS = sizeHandler("xs");
    const handleSM = sizeHandler("sm");
    const handleBase = sizeHandler("base");
    const handleMD = sizeHandler("md");
    const handleLG = sizeHandler("lg");

    mediaQueryXS.addEventListener("change", handleXS);
    mediaQuerySM.addEventListener("change", handleSM);
    mediaQueryBase.addEventListener("change", handleBase);
    mediaQueryMD.addEventListener("change", handleMD);
    mediaQueryLG.addEventListener("change", handleLG);

    return () => {
      mediaQueryXS.removeEventListener("change", handleXS);
      mediaQuerySM.removeEventListener("change", handleSM);
      mediaQueryBase.removeEventListener("change", handleBase);
      mediaQueryMD.removeEventListener("change", handleMD);
      mediaQueryLG.removeEventListener("change", handleLG);
    };
  }, []);

  return children;
};
export default App;
